import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    default: { type: String, default: "table" },
    storageKey: { type: String, default: "view-switcher-view" }
  }

  static targets = ["view", "button"]

  connect() {
    this.show(this.activeView)
  }

  switch({ params: { view } }) {
    if (!view) return
    localStorage.setItem(this.storageKeyValue, view)
    this.show(view)
  }

  show(viewName) {
    this.viewTargets.forEach(el => {
      el.hidden = el.dataset.view !== viewName
    })

    this.buttonTargets.forEach(btn => {
      btn.classList.toggle("active", btn.dataset.viewSwitcherViewParam === viewName)
    })
  }

  get activeView() {
    return localStorage.getItem(this.storageKeyValue) || this.defaultValue
  }
}
